<template>
  <div>
    <el-form size="small" align="center" status-icon :model="formData" :rules="rules" label-suffix=":"
             ref="formData"
             label-width="100px">
      <el-form-item align="left" label="Version" prop="version">
        <!--        <el-input class="el-input&#45;&#45;small" v-model="formData.version"></el-input>-->
        <el-col :span="4">
          <el-form-item prop="pos1">
            <el-input :disabled="true" v-model.number="formData.pos1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <p>.</p>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="pos2">
            <el-input :disabled="true" v-model.number="formData.pos2"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <p>.</p>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="pos3">
            <el-input :disabled="true" v-model.number="formData.pos3"></el-input>
          </el-form-item>
        </el-col>
        <!--<el-col :span="1">
          <p>.</p>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="pos4">
            <el-input v-model.number="formData.pos4"></el-input>
          </el-form-item>
        </el-col>-->
      </el-form-item>

      <el-form-item prop="file" align="left" label="file">
        <label style="margin-left:20px;width: 100px;"
               class="float-left btn-block re-upload-img-btn">
          upload file
          <input ref="file" accept="" type="file" @change="setFile()" class="re-upload-img"/>
        </label>
      </el-form-item>
      <el-form-item align="left" >
        <label v-if="formData.url!=''" style="width: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-html="'file: '+formData.url"></label>
      </el-form-item>

      <el-form-item prop="version_status" align="left" label="Status">
        <!--        <el-switch v-model="formData.is_qa" active-value="1" inactive-value="0"></el-switch>-->
        <el-select style="width: 150px" size="small" v-model="formData.version_status" default-first-option>
          <el-option
            :key=1
            label="Enable"
            :value=1>
          </el-option>
          <el-option
            :key=0
            label="Disable"
            :value=0>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item align="left" label="Last Version" prop="last_version">
        <el-col :span="13">
          <el-input v-model="formData.last_version" placeholder="Please Input Version">
          </el-input>
        </el-col>
      </el-form-item>
      <el-form-item align="left" label="strategy">
        <el-select v-model="formData.strategy" placeholder="strategy">
          <el-option label="direct" :value="1"></el-option>
          <el-option label="prompt" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item align="left" label="md5">
        <el-input v-model="formData.md5" placeholder="uuids"></el-input>
      </el-form-item>
      <el-form-item align="left" label="uuids">
        <el-input v-model="formData.uuids" placeholder="uuids"></el-input>
      </el-form-item>
      <el-form-item prop="description" align="left" label="Description">
        <el-input type="textarea" v-model="formData.description" ></el-input>
      </el-form-item>
      <el-form-item align="right">
        <el-button class="el-button--small" @click="$emit('closeUpdate')">Back</el-button>
        <!--<el-button class="el-button&#45;&#45;small el-button&#45;&#45;warning" @click="$router.push({path:'content'})">Content
        </el-button>-->
        <el-button class="el-button--small el-button--primary" @click="submit('formData')">Save</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'BluetoothUpdate',
    props: {
      closeUpdate:Function,
      updateSucc:Function,
      chooseItem:Object
    },
    data () {
      return {
        version:'',
        rules: {
          /*file:[{required:true,message:"Please select a profile!"}],
          version:[{required:true,message:"Please enter the version number!"}],
          description:'',
          version_status:[{required:true,message:"Please select a status!"}],*/
        },
        formData: {
          pos1: '',
          pos2: '',
          pos3: '',
          //pos4: '',
          version_id:'',
          url:'',
          file:null,
          version:'',
          description:'',
          version_status:0,
          last_version: 'ALL',
          strategy: '1',
          uuids:'',
          md5:''
        },
        rules: {
          pos1: [
            {required: true, message: 'please input', trigger: 'blur'},
            {pattern:/^\d+$/, message: 'please input number', trigger: 'blur'}
          ],
          pos2: [
            {required: true, message: 'please input', trigger: 'blur'},
            {pattern:/^\d+$/, message: 'please input number', trigger: 'blur'}
          ],
          pos3: [
            {required: true, message: 'please input', trigger: 'blur'},
            {pattern:/^\d+$/, message: 'please input number', trigger: 'blur'}
          ],
          version: [
            {required: true}
          ],
          /*pos4: [
            {required: true, message: 'please input', trigger: 'blur'},
            {type: 'number', message: 'please input number', trigger: 'blur'}
          ],*/
          //version:[{required:true,message:"Please enter the version number!"}],
          description: '',
          version_status: [{required: true, message: 'Please select a status!'}],
        },
      }
    },
    created () {
      this.formData=JSON.parse(JSON.stringify(this.chooseItem))
      let cs=this.chooseItem.version.split('.')
      this.$set(this.formData,"pos1",cs[0])
      this.$set(this.formData,"pos2",cs[1])
      this.$set(this.formData,"pos3",cs[2])
      //this.$set(this.formData,"pos4",cs[3])
      this.formData.file=null
      this.filename=this.formData.url
    },
    methods: {
      setFile () {
        this.formData.file = this.$refs['file'].files[0]
        this.formData.audio_name = this.$refs['file'].files[0].name
        this.filename= this.$refs['file'].files[0].name
        this.$refs['formData'].fields[0].validateMessage = ''
        this.$refs['formData'].fields[0].validateState = 'success'
        this.$refs['file'].value = ''
      },
      fileChange () {
        console.log('bluFileChange')
        this.formData.otaFile = this.$refs.file.files[0]
        this.filename=this.$refs.file.files[0].name

        this.$refs.file.value=''
        this.uploadFile()
      },
      uploadFile () {
        if (!this.formData.file) {
          return this.$message.warning('Please select a file!')
        }
        console.log('this.form.otaFile:', this.formData.file)
        var formData = new FormData()
        formData.append('file', this.formData.file)
        formData.append('type', 'blu')

        // 黑幕
        const loading = this.$util.loading('loading...')
        this.$api.rootV1.post('/common/uploadDefault', formData, (res) => {
          loading.close()
          console.log('upload res:', res)
          if (res.errcode === 0) {
            this.$message.success('upload success')
            this.formData.url = res.data.url
            this.$refs['formData'].fields[1].validateMessage = ''
            this.$refs['formData'].fields[1].validateState = 'success'
          } else {
            this.$message.error('upload fail')
          }
        })
      },
      submit (formName) {
        this.formData.version=this.formData.pos1+'.'+this.formData.pos2+'.'+this.formData.pos3//+'.'+this.formData.pos4
        console.log(JSON.stringify(this.formData))
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let form=new FormData()
            form.append('version_id', this.formData.version_id)
            form.append('version', this.formData.version)
            form.append('url', this.formData.url)
            form.append('description', this.formData.description)
            form.append('version_status', this.formData.version_status)
            form.append('last_version', this.formData.last_version)
            form.append('strategy', this.formData.strategy)
            form.append('uuids', this.formData.uuids)
            form.append('md5', this.formData.md5)
            let loading = this.$util.loading()
            this.$api.rootV1.post('/web/otabluetooth/update', form,
              (res) => {
                this.$alert('update successfully!', 'info', {
                  confirmButtonText: 'confirm',
                  type: 'success',
                  callback: action => {
                    loading.close()
                    this.$emit('updateSucc')
                  }
                })
              }, (res) => {
                /*this.$message.error('Update failed!')
                loading.close()*/
                this.$alert(`Update failed!${res.errmsg}`, 'info', {
                  confirmButtonText: 'confirm',
                  type: 'error',
                  callback: action => {
                    loading.close()
                    this.$emit('updateSucc')
                  }
                })
              })
          } else {
            this.$message.warning('Please check the input data!')
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/bluetooth/BluetoothUpdate.vue